import React, { Component } from "react";
import ConfirmarOperacionTransfer from "../ConfirmarOperacionTransfer";
import { mensajeExito } from "../../../generico/MensajeSistemaToast";
import TransferCuentasTercerosService from "../../../../services/transferencias/TransferCuentasTercerosService";
import { splitImporte } from "../../../generico/utils/FormatoInput";
import { trackPromise } from "react-promise-tracker";
import AuthService from "../../../../services/login/auth.service";
import {FontAwesomeIcon}  from "@fortawesome/react-fontawesome";
import {faPlus, faFilePdf} from "@fortawesome/free-solid-svg-icons";

export default class TransferCuentasTerceros extends Component {
  constructor(props) {
    super(props);
    this.newTransfer = this.newTransfer.bind(this);
  }

  getInitialState = () => ({ });
  resetState = () => {
    this.setState(this.getInitialState());
  };
  componentDidMount() {
    this.initData();
    mensajeExito("La Transferencia se Realizó Correctamente");
  }

  initData = () => {
    this.resetState();
  };

  newTransfer() {
    this.props.returnDataPaso3();
    this.firstStep.click();
  }

  descargar = async () => {
    // nroOperacion, cuentaTitular, tipo, moneda, cuentaDebito,cuentaCredito,importeDebito, importeCredito, titularCuentaDestino

    var items = this.props.itemsConfirm;
    var cantidad = items.length;
    var nombreDestino = items[cantidad - 2].valor;
    await trackPromise(


      TransferCuentasTercerosService.descagarComponente("Transferencia entre terceros", this.props.nroOperacion, this.props.cuentaOrigen + " - " + AuthService.getSocio().nombreCompleto, this.props.cuentaOrigenSelected.descripcion, this.props.cuentaOrigenSelected.moneda, this.props.cuentaOrigen, this.props.cuentaDestino, this.props.importe, this.props.importe, nombreDestino)
        .then((response) => {
          var fileURL = URL.createObjectURL(response.data);
          window.open(fileURL, "");
        })
        .catch(function (error) {
          console.log(error);
        })
    );

    this.setState({ listaFactura: true });
    // return listaFactura;
  };


  render() {

    if (this.props.currentStep === 3) {
      //mensajeExito("La Transferencia se Realizó Correctamente")
    }

    return (
      <div>
        <div className="row">
          <div className="steps clearfix">
            <ul role="tablist">
              <li role="tab" className="disabled">
                <span>
                  <div className="title">
                    <span className="title_text current">
                      Selección de Cuentas
                    </span>
                  </div>
                </span>
              </li>
              <li role="tab" className="disabled">
                <span>
                  <div className="title">
                    <span className="title_text">Código de Verificación</span>
                  </div>
                </span>
              </li>
              <li role="tab" className="disabled">
                <span>
                  <div className="title">
                    <span className="title_text">Datos de Verificación</span>
                  </div>
                </span>
              </li>

              <li role="tab" className="current last">
                <span>
                  <div className="title">
                    <span className="title_text">Confirmación</span>
                  </div>
                </span>
              </li>
            </ul>
          </div>
        </div>

        {this.props.cuentaOrigenSelected !== undefined && (
          <ConfirmarOperacionTransfer
            idModal="idModalConfirm3"
            title="Transferencias Entre Cuentas Propias"
            items={this.props.itemsConfirm}
            detalleCuentaBox={this.props.detalleCuenta}
            tipoCuenta={this.props.cuentaOrigenSelected.descripcion}
            moneda={this.props.cuentaOrigenSelected.moneda}
            nroOperacion={this.props.nroOperacion}
          />
        )}

        <div className="row">
          <div className="col-lg-6 col-md-6"></div>
          <div className="col-lg-3 col-md-3 btn-consulta">
          <button
            onClick={this.newTransfer}
            type="button"
            className="btn btn-cu-quintary">
           <FontAwesomeIcon icon={faPlus} />  Nueva Transacción
          </button>
          </div>
          <div className="col-lg-3 col-md-3">
          <button onClick={this.descargar}
            type="button"
            className="btn btn-cu-primary">
          <FontAwesomeIcon icon={faFilePdf} />  Descargar Comprobante
          </button>

          <button
            hidden
            ref={(a) => (this.firstStep = a)}
            onClick={this.props.firstStep}
          ></button>
          </div>
        </div>
      </div>
    );
  }
}
